import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { PALETTES, PALETTE_IDS } from "../../../engine/palettes";

var root = $.from_html(`<button role="radio"><span class="strip svelte-32fe4at5hyspn"></span> <span class="name svelte-32fe4at5hyspn"> </span></button>`);
var root_1 = $.from_html(`<div class="palettes svelte-32fe4at5hyspn" role="radiogroup" aria-label="Palette"></div>`);

export default function PalettePicker($$anchor, $$props) {
	$.push($$props, true);

	// Radiogroup keyboard model: one tab stop (the checked swatch), arrows
	// move selection with wrap-around.
	function onKey(e, i) {
		const delta = e.key === "ArrowDown" || e.key === "ArrowRight"
			? 1
			: e.key === "ArrowUp" || e.key === "ArrowLeft" ? -1 : 0;

		if (delta === 0) return;

		e.preventDefault();

		const next = (i + delta + PALETTE_IDS.length) % PALETTE_IDS.length;
		const id = PALETTE_IDS[next];

		if (!id) return;

		$$props.onchange(id);

		const btn = e.currentTarget.parentElement?.children[next];

		if (btn instanceof HTMLElement) btn.focus();
	}

	var div = root_1();

	$.each(div, 22, () => PALETTE_IDS, (id) => id, ($$anchor, id, i) => {
		const p = $.derived(() => PALETTES[id]);
		var button = root();
		let classes;
		var span = $.child(button);
		var span_1 = $.sibling(span, 2);
		var text = $.child(span_1, true);

		$.reset(span_1);
		$.reset(button);

		$.template_effect(
			($0) => {
				classes = $.set_class(button, 1, 'swatch svelte-32fe4at5hyspn', null, classes, { active: $$props.value === id });
				$.set_attribute(button, 'aria-checked', $$props.value === id);
				$.set_attribute(button, 'tabindex', $$props.value === id ? 0 : -1);
				$.set_style(span, `background: linear-gradient(90deg, ${$0 ?? ''})`);
				$.set_text(text, $.get(p).name);
			},
			[() => $.get(p).stops.join(', ')]
		);

		$.delegated('click', button, () => $$props.onchange(id));
		$.delegated('keydown', button, (e) => onKey(e, $.get(i)));
		$.append($$anchor, button);
	});

	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click', 'keydown']);
import "bun-svelte:PalettePicker.svelte-12p723xgk9x1h-style.css";